module.exports = "/_next/static/images/DataActivation@2x-4ddd32d482b7a4a656dd9baa4a0fe59a.webp";